<template>
  <div class="logo-generator" :class="{disabled: picked === 0}">
    <div class="radio-picker">
      <div class="radio-replacer animal-wrapper" v-for="(item,index) in animals" :key="index" v-if="index > 0" v-on:click="updateAnimal(index)">
        <div class="border" :class="[{active: animals[activeAnimal] == item}, animals[activeAnimal]]">
          <i class="icon" :class="'icon-' + item"></i>
        </div>
        <input type="radio" value="index" v-model="picked">
      </div>
    </div>
    <div id='logo' class="logo-wrapper flex">
      <svg width="100%" height="40%" viewBox="0 0 543 385" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
          <path d="M32.3082865,263.177755 C45.5927322,264.216196 54.5606957,273.064267 54.5606957,287.364637 C54.5606957,302.535185 44.3731356,312.007875 29.6299267,312.007875 C15.7385948,312.007875 5.95723402,303.598242 4.87325892,289.936547 L4.87325892,284.78517 C5.88617701,272.004074 14.4935878,264.152243 26.9523774,263.177755 L32.3082865,263.177755 Z M222.742487,311.153196 L211.977227,311.153196 L211.977227,293.632281 C211.977227,289.43011 211.478665,287.364637 210.552762,286.153842 C209.555637,284.871823 207.988726,284.373261 206.208145,284.373261 C201.578635,284.373261 199.228269,287.00852 199.228269,293.561058 L199.228269,311.153196 L188.331114,311.153196 L188.331114,276.253812 L199.014599,276.253812 L199.014599,280.38476 C201.293742,277.464607 204.783681,275.54158 210.26787,275.54158 C214.541263,275.54158 218.173648,276.894822 220.310345,279.672528 C221.632013,281.379681 222.442726,283.640368 222.742487,287.145955 L222.742487,311.153196 Z M42.5925548,287.364637 C42.5925548,277.250938 36.6810266,272.621428 29.6299267,272.621428 C22.65005,272.621428 16.7385217,277.250938 16.7385217,287.364637 C16.7385217,297.478335 22.65005,302.463962 29.6299267,302.463962 C36.6810266,302.463962 42.5925548,297.478335 42.5925548,287.364637 Z M82.0660526,275.897696 L82.0660526,287.293413 C80.7128112,287.079744 79.0746768,286.866074 77.5077657,286.866074 C74.1602738,286.866074 71.0264517,287.934422 71.0264517,293.774727 L71.0264517,311.153196 L60.1292972,311.153196 L60.1292972,276.253812 L70.6703355,276.253812 L70.6703355,282.165341 C72.5933628,278.604179 75.2998456,276.040143 80.356695,275.826473 C80.9264809,275.826473 81.4962667,275.826473 82.0660526,275.897696 Z M86.7193037,311.153196 L86.7193037,276.253812 L97.6164581,276.253812 L97.6164581,311.153196 L86.7193037,311.153196 Z M86.7193037,272.621428 L86.7193037,263.86097 L97.6164581,263.86097 L97.6164581,272.621428 L86.7193037,272.621428 Z M128.828061,309.158945 L128.828061,305.597784 C126.406471,308.945276 122.346747,310.227294 118.928032,310.227294 C109.740235,310.227294 103.258921,304.458212 103.258921,292.777602 C103.258921,281.310662 110.167574,275.54158 119.497818,275.54158 C122.84531,275.54158 126.833811,276.894822 128.828061,279.814974 L128.828061,276.253812 L139.725215,276.253812 L139.725215,307.022249 C139.725215,312.720107 138.158304,316.993501 135.095705,319.913653 C132.033106,322.762583 127.403596,324.258271 121.420845,324.258271 C110.95103,324.258271 105.680511,318.560412 104.327269,312.007875 L114.227299,311.794205 C115.36687,314.856804 117.717237,315.853929 121.349622,315.853929 C123.557542,315.853929 125.409346,315.42659 126.762587,314.358241 C128.044605,313.289893 128.828061,311.651759 128.828061,309.158945 Z M121.848184,301.466836 C126.121578,301.466836 129.326624,298.119345 129.326624,292.777602 C129.326624,286.937297 126.121578,284.302038 121.848184,284.302038 C117.503567,284.302038 114.369745,286.937297 114.369745,292.848825 C114.369745,298.119345 117.503567,301.466836 121.848184,301.466836 Z M164.376367,312.007875 C152.624534,312.007875 145.359764,304.173319 145.359764,293.489835 C145.359764,282.450234 153.621659,275.256687 164.233921,275.256687 C176.199424,275.256687 183.321747,283.020019 182.467068,296.623657 L156.328142,296.623657 C156.541812,301.039497 160.387866,303.247417 164.447591,303.247417 C168.507315,303.247417 171.000128,301.822953 172.210923,298.974023 L182.324622,300.825827 C179.119576,309.087722 171.854807,312.007875 164.376367,312.007875 Z M164.091474,283.233689 C160.316643,283.233689 156.470589,285.156716 156.399365,289.572557 L171.641137,289.572557 C171.569914,285.22794 167.937529,283.233689 164.091474,283.233689 Z" id="path-1"></path>
        </defs>
        <g id="Brad-Generator-V01" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Brand_Generator_Origen_V01---02" transform="translate(-777.000000, -338.000000)">
            <g id="Logo-Generator" transform="translate(777.000000, 338.000000)">
              <transition name="fade" mode="out-in">
                <polygon id="Fill-1" fill="#A8D9D6" stroke="#A8D9D6" v-if="activeAnimal == 0" key="0" points="4.12626022 179.464079 249.883103 179.464079 249.883103 44.8679981 4.12626022 44.8679981"></polygon>
                <polygon id="Fill-1" fill="#ff7e5b" stroke="#ff7e5b" v-if="activeAnimal == 1" key="1" points="4.12626022 179.464079 249.883103 179.464079 249.883103 44.8679981 4.12626022 44.8679981"></polygon>
                <polygon id="Fill-1" fill="#f2d753" stroke="#f2d753" v-if="activeAnimal == 2" key="2" points="4.12626022 179.464079 249.883103 179.464079 249.883103 44.8679981 4.12626022 44.8679981"></polygon>
                <polygon id="Fill-1" fill="#ffbf80" stroke="#ffbf80" v-if="activeAnimal == 3" key="3" points="4.12626022 179.464079 249.883103 179.464079 249.883103 44.8679981 4.12626022 44.8679981"></polygon>
              </transition>
              <polygon id="col-0-line-3" class="cell" points="250.883103 179.464079 351.830164 179.464079 351.830164 134.598718 250.883103 134.598718" style="opacity: 1;"></polygon>
              <polygon id="col-0-line-4" class="cell" points="250.883103 224.329439 351.830164 224.329439 351.830164 179.464079 250.883103 179.464079"></polygon>
              <polygon id="col-0-line-2" class="cell" points="250.883103 134.598718 351.830164 134.598718 351.830164 89.7333582 250.883103 89.7333582"></polygon>
              <polygon id="col-1-line-2" class="cell" points="351.814336 134.598718 452.761396 134.598718 452.761396 89.7333582 351.814336 89.7333582"></polygon>
              <polygon id="col-0-line-1" class="cell" points="351.830164 44.870636 351.830164 89.7359961 250.883103 89.7333582 250.883103 44.8679981 351.830164 44.870636" style="opacity: 1;"></polygon>
              <polygon id="col-1-line-1" class="cell" points="452.761396 44.870636 452.761396 89.7359961 351.814336 89.7333582 351.814336 44.8679981 452.761396 44.870636"></polygon>
              <polygon id="col-0-line-0" class="cell" points="351.830164 0.00263789747 351.830164 44.8679981 250.883103 44.8653602 250.883103 0 351.830164 0.00263789747"></polygon>
              <polygon id="col-1-line-0" class="cell" points="452.761396 0.00263789747 452.761396 44.8679981 351.814336 44.8653602 351.814336 0 452.761396 0.00263789747"></polygon>
              <polygon id="col-1-line-4" class="cell" points="351.814336 224.329439 452.761396 224.329439 452.761396 179.464079 351.814336 179.464079" style="opacity: 1;"></polygon>
              <polygon id="col-1-line-3" class="cell" points="351.814336 179.464079 452.761396 179.464079 452.761396 134.598718 351.814336 134.598718"></polygon>
              <polygon id="col-2-line-1" class="cell" points="452.81943 89.7333582 542.550151 89.7333582 542.550151 44.869317 452.81943 44.8679981 452.81943 89.7333582" style="opacity: 1;"></polygon>
              <polygon id="col-2-line-3" class="cell" points="452.81943 179.469354 542.550151 179.469354 542.550151 134.605313 452.81943 134.603994 452.81943 179.469354"></polygon>
              <polygon id="col-2-line-4" class="cell" points="452.81943 224.334714 542.550151 224.334714 542.550151 179.470673 452.81943 179.469354 452.81943 224.334714"></polygon>
              <polygon id="col-2-line-0" class="cell" points="452.81943 44.8653602 542.550151 44.8653602 542.550151 0.00131898751 452.81943 0 452.81943 44.8653602"></polygon>
              <polygon id="col-2-line-2" class="cell" points="452.81943 134.601356 542.550151 134.601356 542.550151 89.7373151 452.81943 89.7359961 452.81943 134.601356" style="opacity: 1;"></polygon>
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
              </mask>
              <use id="Clip-22" fill="#000000" xlink:href="#path-1"></use>
                <path d="M222.608458,277.11033 C222.608458,268.681132 228.961499,262.784845 236.892419,262.784845 C244.740294,262.784845 251.134858,268.681132 251.134858,277.11033 C251.134858,285.581052 244.740294,291.352769 236.892419,291.352769 C228.961499,291.352769 222.608458,285.581052 222.608458,277.11033 Z M225.639647,277.11033 C225.639647,283.961649 230.539378,288.612241 236.892419,288.612241 C243.328507,288.612241 248.103668,283.961649 248.103668,277.11033 C248.103668,270.217488 243.328507,265.566896 236.892419,265.566896 C230.539378,265.566896 225.639647,270.217488 225.639647,277.11033 Z M234.442554,278.605163 L234.442554,284.210788 L230.746994,284.210788 L230.746994,269.013317 L236.269572,269.013317 C240.46341,269.013317 243.328507,269.926826 243.328507,273.871525 C243.328507,275.947682 242.290428,277.2349 240.587979,277.940793 L244.200493,284.210788 L240.089702,284.210788 L236.933943,278.605163 L234.442554,278.605163 Z M239.632947,273.913048 C239.632947,272.667354 238.719438,271.919937 237.100035,271.919937 L234.442554,271.919937 L234.442554,275.78159 L237.141558,275.78159 C238.88553,275.78159 239.632947,275.034173 239.632947,273.913048 Z" id="®" fill="#000000"></path>
                <text id="name" font-family="SuisseSans-Bold, Suisse Sans" font-size="71.2232317" font-weight="bold" :class="animals[activeAnimal]" style="display: none;">
                    <tspan x="0.449849448" y="375.615394">{{ name }}</tspan>
                </text>
            </g>
          </g>
        </g>
      </svg>
    </div>
    <div class="input-wrapper">
      <input id="input" type="text" class="text-input" value="" v-bind:placeholder="placeholder" :class="animals[activeAnimal]" v-model="name" v-on:focus="cleanInitial()" v-on:keyup="readInput()">
    </div>
  </div>
</template>

<script>
  import alphabetMapping from '../mixins/alphabetMapping';
  import { TweenMax, Power2 } from 'gsap/TweenMax';

  export default {
    props: {
      placeholder: String
    },
    mixins: [alphabetMapping],
    data () {
      return {
        picked: 0,
        name: '',
        animals: ['default', 'dog', 'horse', 'cat'],
        activeAnimal: 0,
        isFirst: true,
        matrix: [['-', '-', '-', '-', '-'], ['-', '-', '-', '-', '-'], ['-', '-', '-', '-', '-']],
        key: 0,
        fade: [],
        enter: [],
        animatingQueue: []
      };
    },
    methods: {
      updateAnimal (value) {
        this.picked = this.activeAnimal = value;
      },
      readInput () {
        if (this.name.length > 0) {
          document.querySelector('footer').classList.remove('disabled');
        } else {
          document.querySelector('footer').classList.add('disabled');
        }

        const key = event.keyCode || event.charCode;
        this.setKey(key);
      },
      cleanInitial () {
        if (this.isFirst) {
          this.isFirst = false;
          const firstAnim = ['#col-0-line-1', '#col-0-line-3', '#col-1-line-4', '#col-2-line-2', '#col-2-line-1'];

          this.tweenMatrix(firstAnim, 0);
        }
      },
      setKey (key) {
        this.key = key;
      },
      matriceComposition (inserted, old) {
        if (inserted === 1) {
          return 1;
        }
        return old === 1 ? 0 : '-';
      },
      fadeOut (queue, line, col, cell) {
        queue.push('#logo #col-' + col + '-line-' + line);
        this.matrix[col].splice(line, 1, cell);

        return queue;
      },
      fadeIn (queue, line, col, cell) {
        queue.push('#logo #col-' + col + '-line-' + line);
        this.matrix[col].splice(line, 1, cell);

        return queue;
      },
      handleInput (value) {
        const { alphabet, unfrequentLetters, matrix, key, animationController, fadeIn, fadeOut, fillObject } = this;
        const insertedMatrix = [];
        const inputLength = Math.min(3, value.length);

        let { fade, enter } = this;
        let cell = 0;
        let leaveColumn = [];
        let enterColumn = [];

        for (let i = 0; i < inputLength; i++) {
          const isUnfrequentLetter = key !== 16 && typeof alphabet[value[i]] === 'undefined';
          isUnfrequentLetter ? insertedMatrix.push(unfrequentLetters) : insertedMatrix.push(alphabet[value[i]]);
        }

        for (let col = 0; col < matrix.length; col++) {
          for (let line = 0; line < matrix[col].length; line++) {
            if (typeof insertedMatrix[col] !== 'undefined') {
              cell = this.matriceComposition(insertedMatrix[col][line], matrix[col][line]);

              if (cell === 1 && matrix[col][line] !== 1) {
                enterColumn = fadeOut(enterColumn, line, col, cell);
              } else if (cell === 0 && matrix[col][line] === 1) {
                leaveColumn = fadeIn(leaveColumn, line, col, cell);
              }
            } else {
              cell = this.matriceComposition(0, matrix[col][line]);

              if ((cell === 0 && matrix[col][line] !== 0)) {
                leaveColumn = fadeIn(leaveColumn, line, col, cell);
              }
            }
          }

          if (col === matrix.length - 1) {
            enterColumn = enterColumn.reverse();
          } else if (leaveColumn.length > 0) {
            leaveColumn = leaveColumn.reverse();
          }

          enter = [...enter, ...enterColumn];
          fade = [...fade, ...leaveColumn];
          enterColumn = [];
          leaveColumn = [];
        }

        if (fade.length > 0) {
          fillObject(fade, 0);
          animationController();
        }

        fillObject(enter, 1);
        fade = [];
        enter = [];
        animationController();
      },
      fillObject (array, opacity) {
        this.animatingQueue.push({ array: array, opacity: opacity });
      },
      animationController () {
        const { animatingQueue } = this;
        const elems = animatingQueue.shift();

        this.tweenMatrix(elems.array, elems.opacity);
      },
      tweenMatrix (animationArray, opacity) {
        TweenMax.staggerTo(
          animationArray,
          0.160,
          {
            ease: Power2.easeInOut,
            opacity: opacity
          },
          0.05
        );
      }
    },
    watch: {
      name (name, oldname) {
        const input = name.substr(0, 3);
        const lastInput = oldname.substr(0, 3);

        if (input !== lastInput) {
          this.handleInput(input);
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/components/LogoGenerator.vue